import createPersistedReducer from '@/redux/lib/createPersistedReducer';

const initialState = {
  jwt: {},
  settings: {},
  companies: null,
  companiesOptions: [],
  selectedCompany: null,
  sessionCompanyId: null,
  sessionCompanyChannel: null,
  commandBar: [],
  recentActions: [],
  toolbarPosition: { x: 0, y: 0 },
  editorToolbarPosition: { x: 0, y: 0 }
};

const persistConfig = {
  key: 'userReducer',
  whitelist: ['companyId', 'companies', 'companiesOptions', 'selectedCompany', 'recentActions', 'toolbarPosition'],
  transforms: []
};

export default createPersistedReducer(
  initialState,
  {
    LOGOUT: (state) => {
      return {
        ...state,
        jwt: {},
        settings: {}
      };
    },

    SET_USER_PROFILE: (state, payload) => {
      const sameScope = state.jwt.id === payload.jwt.id && state.jwt.companyId === payload.jwt.companyId;
      return {
        ...state,
        settings: payload.settings,
        jwt: {
          ...payload.jwt,
          authorizationCompanyId: sameScope ? state.jwt.authorizationCompanyId : null,
          admin: sameScope && state.jwt.admin === true,
          role: sameScope ? state.jwt.role : null,
          roleId: sameScope ? state.jwt.roleId : null,
          permissions: sameScope ? state.jwt.permissions : null
        }
      };
    },

    GET_USER_STATE_SUCCESS: (state, payload) => {
      const authorization = payload.data?.authorization;
      const activeCompanyId = state.sessionCompanyId || state.jwt.companyId;
      if (!authorization || authorization.userId !== state.jwt.id || authorization.companyId !== activeCompanyId) {
        return state;
      }
      return {
        ...state,
        jwt: {
          ...state.jwt,
          authorizationCompanyId: authorization.companyId,
          admin: authorization.admin,
          role: authorization.role,
          roleId: authorization.roleId,
          permissions: authorization.permissions
        }
      };
    },

    GET_USER_STATE_FAIL: (state, payload) => {
      const activeCompanyId = state.sessionCompanyId || state.jwt.companyId;
      if (payload?.meta?.userId !== state.jwt.id || payload?.meta?.companyId !== activeCompanyId) {
        return state;
      }
      return {
        ...state,
        jwt: { ...state.jwt, authorizationCompanyId: null, admin: false, role: null, roleId: null, permissions: null }
      };
    },

    GET_USER_COMPANIES_SUCCESS: (state, payload) => ({
      ...state,
      companyId: state.companyId || (payload.data?.companies[0] || {}).id,
      companies: payload.data.companies
    }),

    GET_USER_COMPANIES_OPTIONS_SUCCESS: (state, payload) => ({
      ...state,
      companiesOptions: payload?.data?.companies || [],
      selectedCompany: payload?.data?.selectedCompany || null
    }),

    GET_USER_SETTINGS_SUCCESS: (state, payload) => ({
      ...state,
      settings: payload.data?.[0]
    }),

    PUT_COMPANY: (state, payload) => ({
      ...state,
      companies: state.companies.map((n) => (n.id === payload.id ? payload : n))
    }),

    SEARCH_COMMAND_BAR_SUCCESS: (state, payload) => ({
      ...state,
      commandBar: payload.data
    }),

    CLEAR_COMMAND_BAR: (state) => ({
      ...state,
      commandBar: []
    }),

    ADD_RECENT_ACTION: (state, payload) => {
      const maxRecentActions = 10;
      const { item } = payload;
      const timestamp = Date.now();

      // Add timestamp to new action
      const actionWithTimestamp = {
        ...item,
        uniqueKey: `${item.primaryKey}-${timestamp}`,
        timestamp
      };

      // Add new action and sort by timestamp descending
      const recentActions = [...state.recentActions.filter((action) => action.primaryKey !== item.primaryKey), actionWithTimestamp] //
        .sort((a, b) => b.timestamp - a.timestamp)
        .slice(0, maxRecentActions);

      return {
        ...state,
        recentActions
      };
    },

    SET_TOOLBAR_POSITION: (state, payload) => ({
      ...state,
      toolbarPosition: payload
    }),

    SET_SESSION_COMPANY_ID: (state, payload) => {
      if (state.sessionCompanyId === payload) {
        return state;
      }
      const sameCompany = (state.sessionCompanyId || state.jwt.companyId) === (payload || state.jwt.companyId);
      return {
        ...state,
        sessionCompanyId: payload,
        jwt: sameCompany ? state.jwt : { ...state.jwt, authorizationCompanyId: null, admin: false, role: null, roleId: null, permissions: null }
      };
    },

    SET_SESSION_COMPANY_CHANNEL: (state, payload) => ({
      ...state,
      sessionCompanyChannel: payload
    })
  },
  persistConfig
);
